import { useState } from "react";
import { getShellAdminHint } from "@/features/appShell/lib/useAppShell";
import { isAppWindow } from "@/shared/lib/appWindow";
import {
    appWindowKeeps,
    HiddenWorkoutPage,
    SITE_WORKOUT_PAGES_HIDDEN,
    SiteWorkoutPagesMode,
} from "../model/siteWorkoutPages";
import { useNavV5 } from "./useNavV5";

/**
 * Скрыта ли сейчас для этого человека страница `page` — календарь (и всё, что
 * на него ведёт: «Календарь встреч», «К календарю»), план или загрузка файла
 * (рубильник SITE_WORKOUT_PAGES_HIDDEN).
 *
 *   hidden  — скрыта: прямой адрес ведёт на «Тренировки» (карточку приложения);
 *   pending — решать пока не из чего: в режиме "preview" список админов ещё
 *             грузится, а этот браузер помнит человека админом (та же
 *             подсказка, что у оболочки телефона). Тогда страница не рисуется
 *             вовсе, чтобы прежний календарь не мелькнул до перехода.
 * Обычный человек в режиме "preview" ничего не ждёт: для него ответ «нет»
 * сразу, как и до рубильника.
 *
 * Окно приложения (?source=app). В режиме "all" скрыто и там всё, кроме
 * загрузки файла (APP_WINDOW_KEEPS_FIT_UPLOAD): «Загрузить тренировку»
 * приложения v5 открывает именно /account/fit-upload сайта, а календарь и план
 * у приложения свои. В "preview" окно приложения, как прежде, видит всё.
 * Признак окна — при первом взгляде (как у оболочки), один на всех: калитка
 * адресов, «Готово» тестовой тренировки и ссылки «Календарь встреч» видят
 * одно и то же.
 */
export const useSiteWorkoutPagesHidden = (
    page: HiddenWorkoutPage = "calendar",
    mode: SiteWorkoutPagesMode = SITE_WORKOUT_PAGES_HIDDEN,
): { hidden: boolean; pending: boolean } => {
    const { enabled, loading, email, previewAsUser } = useNavV5();
    const [appWindow] = useState(isAppWindow);
    if (mode === "off") return { hidden: false, pending: false };
    if (appWindow) return { hidden: mode === "all" && !appWindowKeeps(page), pending: false };
    if (mode === "all") return { hidden: true, pending: false };
    const remembered = loading && !previewAsUser && !!email && getShellAdminHint() === email.toLowerCase();
    return { hidden: enabled, pending: !enabled && remembered };
};
